import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/*
  Los datos de la cuenta, dentro de la misma pantalla del pago.

  La ruta normal (Ricardo, 16-sep-2026): quien entra a vondi.mx ve lo que hay y
  compra «como en cualquier página de internet», sin una pantalla de registro
  antes del cobro. Cada pantalla de más es un sitio donde se cae la venta.

  Sin «confirmar contraseña»: el ojo para verla cumple el mismo propósito —que
  no se equivoque al teclearla— con un campo menos.

  Mismo aspecto que el resto del checkout: campos en píldora blanca sobre el
  gris claro.
*/

const campo = {
  width: '100%',
  background: '#fff',
  border: '1px solid #E7E7EC',
  borderRadius: 9999,
  padding: '15px 22px',
  fontSize: 16,
  color: '#0E0E10',
  outline: 'none',
};

const rotulo = { display: 'block', color: '#0E0E10', fontWeight: 600, fontSize: 14, margin: '0 0 8px 4px' };

export default function BloqueCuenta({ datos, onChange, onIniciarSesion }) {
  const [ver, setVer] = useState(false);
  const set = (k) => (e) => onChange({ ...datos, [k]: e.target.value });

  return (
    <div style={{ marginBottom: 22 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', margin: '0 4px 12px' }}>
        <h3 className="font-display" style={{ fontSize: 18, fontWeight: 700, color: '#0E0E10', margin: 0 }}>
          Tu cuenta
        </h3>
        <button
          type="button"
          onClick={onIniciarSesion}
          style={{ background: 'none', border: 'none', color: '#6E6E77', fontSize: 13, textDecoration: 'underline', cursor: 'pointer' }}
        >
          Ya tengo cuenta
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div>
          <label style={rotulo} htmlFor="cuenta-nombre">Nombre</label>
          <input id="cuenta-nombre" style={campo} autoComplete="name" value={datos.name} onChange={set('name')} placeholder="Tu nombre completo" />
        </div>
        <div>
          <label style={rotulo} htmlFor="cuenta-correo">Correo</label>
          <input id="cuenta-correo" style={campo} type="email" autoComplete="email" inputMode="email" value={datos.email} onChange={set('email')} placeholder="tu@correo.com" />
        </div>
        <div>
          <label style={rotulo} htmlFor="cuenta-telefono">Teléfono</label>
          <input id="cuenta-telefono" style={campo} type="tel" autoComplete="tel" inputMode="tel" value={datos.phone} onChange={set('phone')} placeholder="10 dígitos" />
        </div>
        <div>
          <label style={rotulo} htmlFor="cuenta-clave">Contraseña</label>
          <div style={{ position: 'relative' }}>
            <input
              id="cuenta-clave"
              style={{ ...campo, paddingRight: 54 }}
              type={ver ? 'text' : 'password'}
              autoComplete="new-password"
              value={datos.password}
              onChange={set('password')}
              placeholder="Mínimo 8 caracteres"
            />
            <button
              type="button"
              onClick={() => setVer((v) => !v)}
              aria-label={ver ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              style={{ position: 'absolute', right: 18, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#6E6E77' }}
            >
              {ver ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/** Lo que tiene que estar antes de crear la cuenta. Devuelve el error o null. */
export function faltaEnCuenta(datos) {
  if (!datos.name.trim()) return 'Escribe tu nombre.';
  if (!/^\S+@\S+\.\S+$/.test(datos.email.trim())) return 'Escribe un correo válido.';
  if (datos.phone.replace(/\D/g, '').length < 10) return 'Escribe tu teléfono a 10 dígitos.';
  if (datos.password.length < 8) return 'La contraseña debe tener al menos 8 caracteres.';
  return null;
}
